import {getServerTexts as getTexts, initTexts, texts} from '../../../../Localization/texts';

const entity = 'UI_SAVESTATUS';

const he = {
    allSaved: 'כל השינויים נשמרו',
    savingChanges: 'שומר שינויים...'
};

const en = {
    allSaved: 'All changes were saved',
    savingChanges: 'Saving changes..'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'AllSaved',
    2: 'SavingChanges'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
